import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../common/utils/getApiReducer';

import { EDIT_SETTINGS, FETCH_SETTINGS } from './actions';

const settingsReducer = getApiReducer(FETCH_SETTINGS);
const settings = (state, action) => {
  let newState = settingsReducer(state, action);

  if (action.type === `${EDIT_SETTINGS}_SUCCESS`) {
    newState = newState.set('data', fromJS(action.json));
  }

  return newState;
};

export default combineReducers({
  settings,
});



// WEBPACK FOOTER //
// ./src/settings/reducers.js